import { useContext, useRef } from "react";
import { useForm } from "react-hook-form";

import PropTypes from "prop-types";

import { ToastContext } from "common/contexts";
import getGAUserID from "common/fetch/getGAUserID";
import sendData from "common/fetch/post";
import trigger from "common/trigger";

import ButtonNew from "components/atoms/ButtonNew/index";
import { BiLoaderAlt } from "components/atoms/Icon/bi/BiLoaderAlt";
import { InputEmail, InputText } from "components/atoms/Input/index";
import ReCaptcha from "components/atoms/Recaptcha/index";
import Title from "components/atoms/Title";
import Toast from "components/atoms/Toast";

/** ========== */
const FormCountry = ({ country_id }) => {
  const { openAlert } = useContext(ToastContext);
  const {
    register,
    handleSubmit,
    reset,
    clearErrors,
    formState: { isSubmitting, errors },
  } = useForm();

  const recaptchaRef = useRef();

  const onSubmit = async (data) => {
    const token = await recaptchaRef.current.executeAsync();

    if (token) {
      const GAUserID = getGAUserID();
      const dataSend = { ...data };

      dataSend.client_id = GAUserID ? GAUserID : "";
      dataSend.website_id = process.env.NEXT_PUBLIC_WEBSITE_ID;
      dataSend.company_country_id = country_id;

      try {
        sendData({
          api: `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/contact_form/question`,
          data: dataSend,
          token,
        })
          .then((res) => {
            if (res.state) {
              trigger("contact_form", dataSend, "Contact form");
              openAlert(2000, "success");
              reset();
            } else {
              openAlert(3000, "error");
              console.log("error");
            }
          })
          .catch((e) => {
            openAlert(3000, "error");
            console.log("error", e);
          });
      } catch (e) {
        clearErrors();
        openAlert(3000, "error");
        console.log("error", e);
      }
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="mb-6 lg:mb-10">
        <InputText
          register={register}
          errors={errors}
          name="first_name"
          placeholder="Name*"
          requiredText="Name is required"
        />
      </div>
      <div className="mb-6 lg:mb-10">
        <InputEmail register={register} errors={errors} />
      </div>
      <div className="mb-6 lg:mb-10">
        <InputText
          as="textarea"
          register={register}
          errors={errors}
          name="message"
          placeholder="Message*"
          requiredText="Message is required"
        />
      </div>
      <div className="flex flex-wrap items-center justify-between">
        <div className="col-12 mb-6 text-center lg:col-auto  lg:mb-0">
          <div className="inline-block">
            <ReCaptcha ref={recaptchaRef} className="mx-auto w-max" />
          </div>
        </div>
        <div className="col-12 text-center lg:col-auto">
          <ButtonNew
            type="submit"
            style={{ minWidth: "170px" }}
            disabled={isSubmitting}
          >
            {isSubmitting && (
              <BiLoaderAlt
                className="mr-2 inline-block animate-spin"
                size={20}
              />
            )}
            Send Your Message
          </ButtonNew>
        </div>
      </div>
    </form>
  );
};

/** ========== */

const FormCountries = ({
  title,
  description,
  descriptionClass,
  contentBottom,
  country_id,
}) => {
  return (
    <div
      className="rounded-3xl bg-white px-3  py-6 lg:px-10 lg:py-[50px]"
      style={{ boxShadow: "0px 16px 40px rgba(181, 181, 181, 0.25)" }}
    >
      <Title
        text={title}
        className="mb-6 text-bbc-30px font-semibold capitalize text-bbc-brand-800 lg:mb-10 lg:text-center lg:text-bbc-40px"
      />
      <p
        className={`${
          descriptionClass ? descriptionClass : "mb-6 text-center lg:mb-10"
        }`}
      >
        {description}
      </p>
      <Toast>
        <FormCountry country_id={country_id} />
      </Toast>
      <div>{contentBottom}</div>
    </div>
  );
};

export default FormCountries;

FormCountries.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  nameProps: PropTypes.object,
  emailProps: PropTypes.object,
  messageProps: PropTypes.object,
  country_id: PropTypes.number,
};

FormCountries.defaultProps = {
  title: "",
  description: "",
  nameProps: {},
  emailProps: {},
  messageProps: {},
};

/** ========== */
